export default "__VITE_PUBLIC_ASSET__219addba__"